import axios from 'axios';

// Use environment variable and append specific route
const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/trees/`;

// Get user's token from local storage
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
};

// Create new tree (with image upload support)
const createTree = async (treeData) => {
  const config = {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'multipart/form-data',
    },
  };
  const response = await axios.post(API_URL, treeData, config);
  return response.data;
};

// Get user's trees
const getMyTrees = async () => {
  const config = {
    headers: getAuthHeader(),
  };
  const response = await axios.get(API_URL + 'mytrees', config);
  return response.data;
};

// Get single tree details
const getTreeById = async (id) => {
  const config = {
    headers: getAuthHeader(),
  };
  const response = await axios.get(API_URL + id, config);
  return response.data;
};

const treeService = {
  createTree,
  getMyTrees,
  getTreeById,
};

export default treeService;